module.exports = __webpack_public_path__ + "150e8cd4ca48bd923428ffc8796b05a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_30.jpg
// module id = 1673
// module chunks = 5